<div class="mobile-message success-message">
	<app-kamona-layout [minHeight]="'calc(100vh - 50px)'">
		<div content>
			<div class="text-center msg-icon flex justify-center">
				<img src="assets/images/svgs/mobile-404.svg">
			</div>
			<div class="title">
				Page Not Found
			</div>
		</div>
		<div footer>
			<div (click)="continue()" class="close-btn">
				<span>{{buttonName}}</span>
			</div>
		</div>
	</app-kamona-layout>
</div>
